<template>
  <div class="py-0" style="right: 0; left: 0;">
    <!-- <b-navbar type="dark" variant="primary" toggleable> -->
    <nav class="navbar navbar-expand-lg navbar-custom py-0">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCustom"
      >
        <i class="fa fa-bars fa-lg py-1 text-white"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarCustom">
        <ul class="navbar-nav">
          <!-- <li class="nav-item active"> 
                  <router-link class="nav-link" href="./">HOME</router-link>
          </li>-->
        </ul>

        <span class="ml-auto mr-5">
          <ul class="navbar-nav">
            <li class="nav-item active">
              <router-link class="nav-link" to="/">Home</router-link>
            </li>
            <li class="nav-item dropdown" style="display:none">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >About Us</a>
              <div class="dropdown-menu dropdown-menu-left" aria-labelledby="navbarDropdown">
                <router-link class="dropdown-item" to="/about">Overview</router-link>
                <router-link class="dropdown-item" to="/boards" style="display:none">List of Boards</router-link>
                <!-- <router-link class="dropdown-item" href="/organization">Organisation Structure</router-link>
                          <router-link class="dropdown-item" href="/function">Functions</router-link>
                <router-link class="dropdown-item" href="/power">Power And Duties of Boards</router-link>-->
              </div>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/EProfile">Registration</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/download">Downloads</router-link>
            </li>

            <li class="nav-item dropdown" style="display:none">
              <!-- <router-link class="nav-link" href="/download">Downloads</router-link> -->
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >Downloads</a>
              <div class="dropdown-menu dropdown-menu-left" aria-labelledby="navbarDropdown">
                <router-link class="dropdown-item" to="/ActRule">Act &amp; Rules</router-link>
                <router-link class="dropdown-item" to="/Notification">Notifications</router-link>
                <router-link class="dropdown-item" to="/Circular">Circulars</router-link>
                <router-link class="dropdown-item" to="/report">Report</router-link>
              </div>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" to="/contact">Contact Us</router-link>
            </li>
          </ul>
        </span>
      </div>
    </nav>
    <!-- </b-navbar> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
.navbar-custom {
  background-color: #0A0032 !important;
  min-height: 70px;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  line-height: 54px;
  font-family: "Open sans", sans-serif;
  text-transform: uppercase;
}
/* change the brand and text color */
.navbar-custom .navbar-brand,
.navbar-custom .navbar-text {
  color: white;
}
/* change the link color */
.navbar-custom .navbar-nav .nav-link {
  color: white;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  padding-left: 30px;
  text-transform: uppercase;
}
/* change the color of active or hovered links */
.navbar-custom .nav-item.active .nav-link,
.navbar-custom .nav-item:hover .nav-link {
  color: #f4ff60;
  padding-left: 30px;
}

.navbar-custom .dropdown-menu {
  background-color: #0A0032 !important;
  margin-left: -50px;
}
.navbar-custom .dropdown-menu-left {
  background-color: #0A0032 !important;
  margin-left: 10px !important;
}
.navbar-custom .dropdown-item {
  color: #ffffff;
  height: 40px !important;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  line-height: 34px;
  padding-left: 30px;
  text-transform: uppercase;
}
.navbar-custom .dropdown-item:hover,
.navbar-custom .dropdown-item:focus {
  /* color: #333333;
  background-color: rgba(255, 255, 255, 0.5); */
  color: black;
  background-color: white;
  display: block;
}

/* Dropdown Button */
.navbar-custom .dropbtn {
  height: 70px;
  background-color: #0A0032 !important;
  color: white;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;

  font-family: "Open sans", sans-serif;
  border: none;
  padding-left: 30px;
  text-transform: uppercase;
}

/* The container <div> - needed to position the dropdown content */
.navbar-custom .dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #0A0032;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: white;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #ddd;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn:hover {
  background-color: #f4ff60;
}

.header_aera .navbar-collapse .navbar-nav.navbar-right li a {
  margin-top: -15px;
}
</style>


// WEBPACK FOOTER //
// src/components/PortalNavbar.vue